import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { Box, Grid } from '@mui/material';
import { useTheme } from '@mui/styles';

import { getUrl } from '@utils/ApiAction';
import useNotificationLoading from '@utils/useNotificationLoading';

import CommissionDashboard from './CommissionDashboard';
import WalletDashboard from './WalletDashboard';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className="lh-0" p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default function Index(props) {
    const [state, setState] = useState({
        pageIndex: null,
        subPage: 'wallet',
        wallets: [],
        walletSetting: [],
        walletIndex: 0,
        commissions: [],
        commissionIndex: 0,
        totalComm: [],
        walletDecimal: 2,
    });

    const { t } = useTranslation();
    const theme = useTheme();
    let navigate = useNavigate();
    let { page } = useParams();

    const isMountedRef = useRef(null);
    const { addAlert, setLoading } = useNotificationLoading();

    useEffect(() => {
        if (page) {
            if (_.includes(['wallet', 'commission'], page)) {
                setState({
                    ...state,
                    pageIndex: page === 'commission' ? 1 : 0,
                    subPage: page,
                })
            }
        }
    }, [page]);

    useEffect(() => {
        isMountedRef.current = true;
        setLoading(true);
        if (state.pageIndex !== null) {
            let apiUrl = '/user/wallets';
            let param = {};
            if (state.pageIndex === 0) {
            } else if (state.pageIndex === 1) {
                apiUrl = '/user/commissions';
                param = { brief: true };
            }

            getUrl(apiUrl, param).then(response => {
                if (response.status && isMountedRef.current) {
                    if (state.pageIndex === 0) {
                        setState({ ...state, wallets: Object.values(response.data.wallet_list), walletSetting: response.data.wallet_setting });
                    } else if (state.pageIndex === 1) {
                        setState({ ...state, commissions: Object.values(response.data.comm), totalComm: response.data.total });
                    }
                }
            }).catch(error => {
                addAlert('', error.message || t('error.contactSupport'), 'error', '');
            }).finally(() => {
                setLoading(false);
            });
        }

        return () => isMountedRef.current = false;
        // eslint-disable-next-line
    }, [state.pageIndex]);

    const handleChange = (value) => {
        navigate(`/wallets/${value === 1 ? 'commission' : 'wallet'}`);
    };

    return (
        <div className='p-b-150 p-t-95' style={{ minHeight: '100vh', overflowY: 'hidden' }}>
            {
                !_.isNull(state.pageIndex) &&
                <Box className="p-lr-15 p-t-50">
                
                    <div className='p-lr-35'>
                        <div className='btn-tab-bkg flex-m'>
                            <div
                                value={0}
                                onClick={() => handleChange(0)}
                                style={{width: '50%'}}
                                className={`${state.pageIndex === 0 ? 'btn-tab-selected' : 'btn-tab-default'} flex-c-m `}>
                                <p className='fs-14 inter-normal'>{t('title.wallet')}</p>
                            </div>
                            <div
                                value={1}
                                style={{width: '50%'}}
                                onClick={() => handleChange(1)}
                                className={`${state.pageIndex === 1 ? 'btn-tab-selected' : 'btn-tab-default'} flex-c-m `}>
                                <p className='fs-14 inter-normal'>{t('title.commission')}</p>
                            </div>
                        </div>
                        {/* <p className='fs-18 cl-white inter-normal'>{t('title.wallet')}</p> */}
                    </div>
                    <div className='p-tb-20'>
                        {/* /////////  Wallet /////////*/}
                        <TabPanel value={state.pageIndex} index={0} dir={theme.direction}>
                            <Grid item xs={12}>
                                <WalletDashboard state={state} setState={setState} />
                            </Grid>
                        </TabPanel>

                        {/* /////////  Commission  /////////*/}
                        <TabPanel value={state.pageIndex} index={1} dir={theme.direction}>
                            <Grid item xs={12}>
                                <CommissionDashboard state={state} setState={setState} />
                            </Grid>
                        </TabPanel>
                    </div>
                </Box>
            }
        </div>
    )
}